<template>
	<b-modal
		:hide-footer="true"
		:title="$t('Upload de arquivos')"
		centered
		id="upload"
	>
		<div class="row px-3">
			<div class="col-12 alert alert-danger" v-if="error">
				{{ error }}
			</div>
			<div class="row col-12 px-3 d-flex justify-content-center" v-if="loading">
				<load mode="table" />
				<h5 class="my-3">
					Enviando <b>{{ files.length }}</b> arquivo(s)
				</h5>
			</div>
			<form v-else @submit.prevent="submit" ref="addItem" class="col-12 px-0">
				<div class="row">
					<form-file
						@submit="submitFile"
						multiple
						btn-text="Iniciar"
						:progress="progressCompleted"
					/>
				</div>
				<div class="row px-2 d-flex justify-content-end">
					<button class="btn btn-primary btn-sm" @click="submit">Enviar</button>
				</div>
			</form>
		</div>
	</b-modal>
</template>
<script>
export default {
	props: ["path", "pathRoot", "item"],
	data() {
		return {
			nome: "",
			error: "",
			loading: false,
			files: "",
			progressCompleted: 0,
		};
	},
	methods: {
		submitFile(files) {
			this.files = files;
		},
		submit() {
			this.loading = true;
			this.error = null;
			let formData = new FormData();

			if (this.files.length > 0 && this.files.length != undefined) {
				for (const i of Object.keys(this.files)) {
					formData.append("files[]", this.files[i]);
				}
			} else {
				formData.append("files", this.files);
			}

			formData.append("caminho", this.path);
			formData.append("caminho_root", this.pathRoot);
			formData.append("id", this.item.id);

			axios
				.post(`api/dashboard/documento/upload`, formData, {
					header: { "Content-Type": "multipart/form-data" },
					onUploadProgress: (event) => {
						let progress = Math.round((event.loaded * 100) / event.total);
						this.progressCompleted = progress;
					},
				})
				.then((response) => {
					if (response.data.error) {
						this.error = response.data.error;
					} else {
						this.$emit("upload-completed", this.path);
						this.error = null;
						this.nome = "";
					}
				})
				.finally(() => {
					this.progressCompleted = 0;
					this.files = [];
					this.$bvModal.hide("upload");
					this.loading = false;
				});
		},
	},
};
</script>
